module.exports = __webpack_public_path__ + "img/complete.7fd1414c.svg";